import { render, staticRenderFns } from "./PreviewSpecialOfferComponent.vue?vue&type=template&id=87517be8&scoped=true"
import script from "./PreviewSpecialOfferComponent.vue?vue&type=script&lang=js"
export * from "./PreviewSpecialOfferComponent.vue?vue&type=script&lang=js"
import style0 from "./PreviewSpecialOfferComponent.vue?vue&type=style&index=0&id=87517be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87517be8",
  null
  
)

export default component.exports